import type { FC } from 'react';
import Modal from 'react-modal';

import * as st from './styles.module.scss';

type Props = {
	isOpen: boolean;
	toggle: () => void;
	children?: React.ReactNode;
};

Modal.setAppElement('#root');

export const ModalSettings: FC<Props> = ({ isOpen, toggle, children }) => {
	return (
		<Modal
			className={st.modal}
			overlayClassName={st.overlay}
			isOpen={isOpen}
			onRequestClose={toggle}
		>
			{children}
		</Modal>
	);
};
